import { InstallationStatusChange, InstallationStatusChangeForUI } from "../InstallationStatusChange";
import { VersionObfuscator } from "../updates/VersionObfuscator";
import { InstallationSummary } from "./InstallationSummary";
import { WidgetDataResponseStatus } from "./WidgetDataResponseStatus";
import { WidgetSingleSerie } from "./WidgetSingleSerie";

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export class WidgetData {
    status: WidgetDataResponseStatus = WidgetDataResponseStatus.Ok;
    statusMessage: string = "";
    labels: string[] = [];
    series: WidgetSingleSerie[] = [];
    installationSummaries: InstallationSummary[] = [];
    installationsStatusHistory: InstallationStatusChangeForUI[] = [];

    fillFromJson(data: any) {
        this.statusMessage = data.StatusMessage;
        this.status = data.Status;

        // this.labels = data.Labels || [];
        // this.labels = this.labels.map((l) => VersionObfuscator.obfuscate(l));

        var tempLabels: string[] = data.Labels || [];
        tempLabels = tempLabels.map((l) => VersionObfuscator.obfuscate(l));

        if (data.Series) {
            data.Series.forEach((jsonSerie: any) => {
                var s = new WidgetSingleSerie();
                s.fillFromJson(jsonSerie);
                this.series.push(s);
            });
        }

        this.labels = tempLabels.filter(onlyUnique);
        tempLabels.forEach((label, idx) => {
            // console.group("label", label, idx);
            // console.log("check label", label, idx);
            // console.log("this.labels.indexOf(label) ", this.labels.indexOf(label));

            if (this.labels.indexOf(label) != idx) {
                // ho accorpato
                this.series.forEach((s) => {
                    s.move(idx, this.labels.indexOf(label));
                });
            }
            console.groupEnd();
        });

        this.series.forEach((s) => {
            s.removeUndefinedValues();
        });

        if (data.InstallationSummaries) {
            data.InstallationSummaries.forEach((jsonInstallationSummary: any) => {
                var s = new InstallationSummary();
                s.parse(jsonInstallationSummary);
                this.installationSummaries.push(s);
            });
        }

        if (data.InstallationsStatusHistory) {
            data.InstallationsStatusHistory.forEach((jsonInstallationStatusChange: any) => {
                var s = new InstallationStatusChangeForUI();
                s.parse(jsonInstallationStatusChange);
                this.installationsStatusHistory.push(s);
            });
        }
    }
}
